module.exports = __webpack_public_path__ + "img/road-cars-day.84db1f5a.jpg";